import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { PayerPayeeEngagementStatus } from "@wingspanhq/payments/dist/interfaces";
import { PaymentsEligibility } from "@wingspanhq/payments/dist/interfaces/payerPayee";

export const selectorPayeeHasEligibleEngagements = (
  engagements: IPayeeEngagementResponse[]
) => {
  return engagements
    .filter(
      engagement => engagement.status === PayerPayeeEngagementStatus.Active
    )
    .some(
      engagement =>
        engagement.paymentsEligibility === PaymentsEligibility.Eligible
    );
};
